var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { getQueryHash } from "../utils/hash.utils";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./property.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getAllWhere = _a.getAllWhere, getCreatedDetail = _a.getCreatedDetail, getCount = _a.getCount, isFetchingCount = _a.isFetchingCount, fetchCountError = _a.fetchCountError, 
// getInfiniteLoad,
isCreating = _a.isCreating, createError = _a.createError, isUpdating = _a.isUpdating, updateError = _a.updateError, isRemoving = _a.isRemoving, removeError = _a.removeError;
export var isFetchingPaged = function (state, query) {
    var hash = getQueryHash(query);
    return state[REDUCER_KEY].paged[hash];
};
